const NUMBER_TYPE = 'number';

export function profileSalaryAmount(value: number): number | null {
  return typeof value === NUMBER_TYPE && isFinite(value) ? value : null;
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/views/view-user-profile/view-user-profile-payroll.presentation.ts